import _ from 'lodash';
import storage from './storage';
import constants from './constants';
import message from 'framework/modules/message';
import {siteContext} from '../config';

let vas = {
    get(productGuid) {
        let userVasDetails = storage.get(constants.STORAGE.USER_VAS_DETAILS);
        let id;
        let i;

        if (_.isUndefined(userVasDetails)) {
            return null;
        }

        for (i = 0; i < userVasDetails.orderItems.length; i++) {
            id =
                userVasDetails.orderItems[i].productGuid ||
                userVasDetails.orderItems[i].type;
            if (id.toLowerCase() === productGuid.toLowerCase()) {
                return userVasDetails.orderItems[i];
            }
        }

        return null;
    },

    getVasAndBrandTooltip() {
        const vasOptionsSelected = this.hasVasOptionsSelected(
            storage.get(constants.STORAGE.USER_VAS_DETAILS)
        );

        return vasOptionsSelected
            ? message.read('payment.products.services.vas.tooltip', {
                  brand: siteContext?.humanReadableBrandName,
              })
            : message.read('payment.products.services.tooltip', {
                  brand: siteContext?.humanReadableBrandName,
              });
    },

    hasProductGuid(products, productGuid) {
        let productGuids = _.map(products, 'productGuid');

        return _.includes(productGuids, productGuid);
    },

    hasVasOptionsSelected(userVasDetails) {
        if (
            _.isObject(userVasDetails) &&
            _.isArray(userVasDetails.orderItems) &&
            userVasDetails.orderItems.length > 0
        ) {
            return !_.isUndefined(
                _.find(userVasDetails.orderItems, (orderItem) => {
                    // exclude RDD - an RDD election is not considered VAS
                    return orderItem.type !== 'RDD';
                })
            );
        }

        return false;
    },

    /**
     * Return comma delimited list of VAS labels, ignoring RDD
     * @param userVasDetails the json that is stored from checkout page of user's VAS elections
     */
    getLocalizedListOfSelectedVas(userVasDetails) {
        let listOfSelectedVas = '';

        if (
            _.isUndefined(userVasDetails) ||
            _.isUndefined(userVasDetails.orderItems)
        ) {
            return null;
        }

        listOfSelectedVas = _.chain(userVasDetails.orderItems)
            .filter((orderItem) => {
                return orderItem.type !== 'RDD';
            })
            .map((orderItem) => {
                return orderItem.label;
            })
            .value()
            .join(', ');

        return listOfSelectedVas;
    },

    isValidNumberFormat(input) {
        return /^[0-9]\d{0,2}(,\d{3})*(\.\d+)?$|^[0-9]\d{0,5}(\.\d+)?$|^[0-9]\d{0,5}(,\d+)?$|^[0-9]\d{0,2}(\.\d{3})*(,\d+)?$|^[0-9]\d{0,2}(\s\d{3})*(,\d+)?$/.test(
            input
        );
    },

    getCostPerDay(vasProduct, optionsID) {
        let i;

        if (!_.isUndefined(vasProduct.costPerDay)) {
            return vasProduct.costPerDay;
        }

        if (!_.isUndefined(vasProduct.options)) {
            for (i = 0; i < vasProduct.options.length; i++) {
                if (
                    vasProduct.options[i].cost.amount ===
                    parseInt(optionsID, 10)
                ) {
                    if (_.isUndefined(vasProduct.options[i].costPerDay)) {
                        return null;
                    }
                    return vasProduct.options[i].costPerDay.localized;
                }
            }
        }

        return null;
    },

    hasVas(eligibleProducts) {
        const countries = _.get(eligibleProducts, 'countries', []);
        return _.isArray(countries) && countries.length > 0;
    },

    getProducts(eligibleProducts) {
        return vas.hasVas(eligibleProducts)
            ? eligibleProducts.countries[0].products
            : null;
    },
};

export default vas;
